import { addGST } from '../../../util/addGst'
import { fixedDigit } from '../../../util/fixedDigit'
import { CartItem } from '../../cart/storage/cart.types'

const calculateBasePrice = (products: CartItem[]) => {
  return products.reduce((prev, curr) => {
    if (curr.editedPriceExcGst) {
      return prev + curr.editedPriceExcGst * curr.quantity
    }
    return prev + curr.basePriceExcGst
  }, 0)
}

const calculateDiscountedPrice = (products: CartItem[]) => {
  return products.reduce((prev, curr) => {
    if (curr.editedPriceExcGst) {
      return prev + curr.editedPriceExcGst * curr.quantity
    }
    return prev + curr.discountedPriceExcGst
  }, 0)
}

export const calculateBasePriceIncGST = (products: CartItem[], freightChargeExcGst?: number) => {
  let cost = calculateBasePrice(products)
  if (freightChargeExcGst) {
    cost += freightChargeExcGst
  }
  return fixedDigit(addGST(cost), 2)
}

export const calculateDiscountedPriceIncGst = (
  products: CartItem[],
  freightChargeExcGst: number | null,
) => {
  let cost = calculateDiscountedPrice(products)
  if (freightChargeExcGst) {
    cost += freightChargeExcGst
  }
  return fixedDigit(addGST(cost), 2)
}

export const calculateTotalGST = (products: CartItem[]) => {
  return fixedDigit(calculateDiscountedPrice(products) * 0.15, 2)
}

export const calculateTotalDiscount = (products: CartItem[]) => {
  const discount = products.reduce((prev, curr) => {
    if (curr.editedPriceExcGst) {
      return prev + (curr.basePriceExcGst - curr.editedPriceExcGst * curr.quantity)
    }
    return prev + (curr.basePriceExcGst - curr.discountedPriceExcGst)
  }, 0)
  return fixedDigit(addGST(discount), 2)
}

export const calculateNewDiscountedPriceExcGst = (product: CartItem, newQuantity: number) => {
  if (product.editedPriceExcGst) {
    return product.editedPriceExcGst * newQuantity
  }
  if (product.quantity && product.discountedPriceExcGst) {
    return (product.discountedPriceExcGst * newQuantity) / product.quantity
  }
  return 0
}

export const calculateNewBasePriceExcGst = (product: CartItem, newQuantity: number) => {
  if (product.quantity && product.basePriceExcGst) {
    return (product.basePriceExcGst * newQuantity) / product.quantity
  }
  return 0
}

export const calculatePriceForNewQuantity = (
  price: number,
  originalQuantity: number,
  newQuantity: number,
) => {
  return (price * newQuantity) / originalQuantity
}
